import React from 'react';
// utils
import { getEvent } from '../utils';
// components
import Day from './Day';
// styles
import styles from './Week.mod.css';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

const Week = ({
  currentMonthView,
  selected,
  select,
  events,
  previousCurrentNextView,
  recoveryStats,
  isDailyCheckIn,
  color,
}) => {
  const daysParams = [];
  let date = previousCurrentNextView;

  for (let i = 0; i < 7; i++) {
    const hasEvents = getEvent({ date, events });
    const hasRecoveryStats =
      isDailyCheckIn &&
      recoveryStats &&
      recoveryStats[date.format('YYYY-MM-DD')];
    const day = {
      name: date.format('dd').substring(0, 1),
      number: date.date(),
      isCurrentMonth: date.month() === currentMonthView.month(),
      isToday: date.isSame(new Date(), 'day'),
      hasRecoveryStats,
      isDailyCheckIn,
      date,
      hasEvents,
    };
    date = date.clone();
    date.add(1, 'd');
    daysParams.push(day);
  }

  return (
    <div className={cx('wrapper')}>
      {daysParams.map((day, index) => (
        <Day
          key={index}
          color={color}
          day={day}
          selected={selected}
          select={select}
        />
      ))}
    </div>
  );
};

export default Week;



// WEBPACK FOOTER //
// ./src/components/Calendar/components/Week.jsx